export default __webpack_public_path__ + "static/media/dashboard.3952c477.svg";